import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ActualitiesService } from '@features/dashboard/mes-actualites/services/actualities.service';
import * as ActualitiesActions from '@features/dashboard/mes-actualites/stores/actualities.actions';

@Injectable()
export class ActualitiesEffects {

    loadActualities$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ActualitiesActions.loadActualities),
            mergeMap(action =>
                this.actualitiesService.getActualities(action.sourceName).pipe(
                    map(actualities => ActualitiesActions.loadActualitiesSuccess({ actualities })),
                    catchError(error => of(ActualitiesActions.loadActualitiesFailure({ error })))
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private actualitiesService: ActualitiesService
    ) { }
}
